import { InvoiceRepository } from "../../repositories/InvoiceRepository";
import {
  ManualInvoiceCreatedEntity,
  InvoiceDataEntity,
} from "../../entities/InvoiceEntity";

/**
 * Create Manual Invoice Use Case
 * Creates an invoice from form data (and optional attachments) and pushes to Zoho.
 */
export class CreateManualInvoiceUseCase {
  constructor(private repository: InvoiceRepository) {}

  async execute(
    invoiceData: InvoiceDataEntity,
    companyGstEnabled: number,
    attachments?: File[]
  ): Promise<ManualInvoiceCreatedEntity> {
    return this.repository.createManualInvoice(
      invoiceData,
      companyGstEnabled,
      attachments
    );
  }
}
